

import $ from 'jquery';
import noticeData from '../data/NoticeData';

    /*
    게시판 v2.0
    ul li 스타일로 구현된 게시판
    data관리와 스크립트 기능을 분리
    적용이후 수정과정 최소화
    **/
const NoticeUtil = () => {
    

        //  전역변수
    //  게시물 배열길이(게시물 총 개수) / 페이지당 보여줄 게시물의 개수 /  페이지네이션 자르기단위 / 페이지네이션 길이
    //  현재 위치중인 페이지 네이션 index / 선택된 게시물 index / 카테고리
 
    let noticeTotal = 0;
    let noticeSliceCount = 10;

    let noticePagination = 0;

    let noticePaginationIndex = 1;


    let noticeViewArray = [];
    let paginationArray = [];
    //  함수
    //  초기값 설정
    function initNotice() {
        // 데이터 사본 생성=
        noticeViewArray = noticeData;
        // 총 게시물수 저장
        noticeTotal = noticeViewArray.length;
        // 페이지 개수 설정
        noticePagination = Math.ceil(noticeTotal / noticeSliceCount);
        // 페이지네이션 배열 생성
        // console.log("noticePagination");
        // console.log(noticePagination);
        for (let i = 1; i <= noticePagination; i++) {
            paginationArray.push(i);
        }
        // 페이지네이션 버튼 설정
        drawPagination();
        // 초기화
        noticePaginationIndex = 1;
        
        // 게시물 생성
        sliceNotice();
        // 설정 확인용 콘솔
        // console.log("noticecategory");
        // console.log(noticeCategory);
        // console.log("noticeViewArray");
        // console.log(noticeViewArray);
        // console.log("paginationArray");
        // console.log(paginationArray);
        // console.log("noticeTotal");
        // console.log(noticeTotal);
        // console.log("noticePagination");
        // console.log(noticePagination);
    }
    //  카테고리+페이지에 따라 게시물 보여주기
    function drawNoticeRow(showNotice) {
        // console.log(showNotice);
        document.querySelector(".notice-wrapper").innerHTML = "";
        showNotice.map((itm, index) => {
            // console.log(itm)
            let parent = document.querySelector(".notice-wrapper");
            let str = document.createElement("div");
            let widthIdx = 0;
            let number = itm.no;
            str.setAttribute("class", "notice-item");
            str.setAttribute("tabindex", 0);
            // console.log(number);
            str.addEventListener("click", function () {
                // console.log(number);
                viewNotice(number);
            });
            str.addEventListener("keydown", function (event) {
                if (event.key === "Enter" || event.key === " ") {
                    viewNotice(number);
                }
            });
            for (let prop in itm) {
                if (prop === "date" || prop === "title") {
                    let text = document.createElement("p");
                    text.innerHTML = itm[prop];
                    str.appendChild(text);
                }
                widthIdx++;
            }
            // str.style.cssText = `width: ${noticeData[noticeCategory].width[index]}%`;
            // str.innerHTML = parent.appendChild(str);
            parent.appendChild(str);
        });
    }
    // 페이지네이션
    // 페이지네이션 그리기
    function drawPagination() {
        let parent = document.querySelector(".notice-pagination");
        let foo = Math.floor(noticePaginationIndex / 10) * 10;
        let showPagination = paginationArray.slice(foo, foo + 10);
        for (let i = 1; i <= noticePagination; i++) {
            let str = document.createElement("li");
            str.setAttribute("class", "pagination");
            str.setAttribute("tabindex", 0);
            if (i === 1) {
                str.classList.add("active");
            }
            str.setAttribute("onclick", `movePage(${i})`);
            str.addEventListener("click", function () {
                movePage(i);
            });
            str.addEventListener("keydown", function (event) {
                if (event.key === "Enter" || event.key === " ") {
                    movePage(i);
                }
            });
            str.innerHTML = `${i}`;
            parent.appendChild(str);
        }
    }
    // 페이지 이동(이전 페이지 버튼3종)
    function prevPage(order) {
        switch (order) {
            case `one`: {
                if (noticePaginationIndex > 1) {
                    movePage(noticePaginationIndex - 1);
                    sliceNotice();
                }
                break;
            }
            case `slice`: {
            }
            case `start`: {
                if (noticePaginationIndex > 1) {
                    movePage(1);
                    sliceNotice();
                }
                break;
            }
        }
    }
    // 페이지 이동(다음 페이지 버튼3종)
    function nextPage(order) {
        // console.log("next");
        switch (order) {
            case `one`: {
                if (noticePaginationIndex != noticePagination) {
                    movePage(noticePaginationIndex + 1);
                    sliceNotice();
                }
                break;
            }
            case `slice`: {
                break;
            }
            case `end`: {
                if (noticePaginationIndex != noticePagination) {
                    movePage(noticePagination);
                    sliceNotice();
                }
                break;
            }
        }
    }
    // 선택한 페이지로 이동
    function movePage(moveindex) {
        noticePaginationIndex = moveindex;
        $(`.pagination:nth-of-type(${noticePaginationIndex})`).addClass("active");
        $(`.pagination:nth-of-type(${noticePaginationIndex})`).siblings().removeClass("active");
        sliceNotice();
    }
    // 배열을
    function sliceNotice() {
        // console.log(noticeViewArray);
        // console.log("index" + noticePaginationIndex);
        // console.log((noticePaginationIndex - 1) * 10);
        let showNotice = [...noticeViewArray.slice((noticePaginationIndex - 1) * noticeSliceCount, (noticePaginationIndex - 1) * noticeSliceCount + noticeSliceCount)];

        drawNoticeRow(showNotice);
    }
    // 공지사항 뷰어페이지로 이동하기
    function viewNotice(number) {
        window.location.href = `./noticeview?no=${number}`;
        //navigate(`./noticeview?no=${number}`,{state: noticeData});
    }
    window.onload = function () {
        initNotice();
    };

    return {
        prevPage,
        nextPage
    };
};

export default NoticeUtil;
